import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/ngos/portals')({
	component: () => <Outlet />,
});
